import Flickity from "flickity";

function sliderDobleMalta(SELECTORS, context) {
  const ins = {};
  for (const instance in SELECTORS) {
    ins[instance] = [...context.querySelectorAll(SELECTORS[instance])];
    if (ins[instance].length) {
      for (const component of ins[instance]) {
        if (component.children.length > 1) {
          const flickity = new Flickity(component, {
            cellAlign: "left",
            wrapAround: false,
            lazyLoad: true,
            contain: true,
            pageDots: true,
            adaptiveHeight: true,
            imagesLoaded: true,
            prevNextButtons: true
          });
        }
      }
    }
  }
}

function CreaterModal(productOne, parentModal, context) {
  let mainDiv = context.createElement("div");
  let closeDiv = context.createElement("div");

  mainDiv.classList.add("box__slider--doblemalta");
  mainDiv.classList.add("box_hover");
  closeDiv.classList.add("box__close--simple");
  parentModal.appendChild(closeDiv);

  closeDiv.addEventListener("click", function () {
    mainDiv.classList.remove("active--hover");
    this.classList.remove("active--hover");
  })

  for (let index = 0; index < productOne.length; index++) {
    const element = productOne[index]
    let mainDivWrapper = context.createElement("div");
    let imgDiv = context.createElement("div");
    let titleDiv = context.createElement("div");
    let bodyDiv = context.createElement("div");

    imgDiv.innerHTML = element.children[0].outerHTML;
    titleDiv.innerHTML = element.children[1].innerText;
    bodyDiv.innerHTML = element.children[2].innerText;

    imgDiv.classList.add("box__image--simple");
    titleDiv.classList.add("box__title--simple");
    bodyDiv.classList.add("box__body--simple");
    mainDivWrapper.classList.add("box_hover--wrapper");


    mainDivWrapper.appendChild(imgDiv);
    mainDivWrapper.appendChild(titleDiv);
    mainDivWrapper.appendChild(bodyDiv);

    mainDiv.appendChild(mainDivWrapper);
    element.addEventListener("click", function (e) {
      mainDiv.classList.add("active--hover");
      closeDiv.classList.add("active--hover");

      let indexClick = index;
      let Dot = parentModal.querySelectorAll('.box__slider--doblemalta .flickity-page-dots .dot');
      for (let indexdot = 0; indexdot < Dot.length; indexdot++) {
        const elementDot = Dot[indexdot];
        if (indexClick == indexdot) {
          elementDot.click();
        }
      }
    });
  }
  parentModal.appendChild(mainDiv);
  setTimeout(() => {
    const SELECTORS = {
      componentGeneral: ".box__slider--doblemalta",
    }
    sliderDobleMalta(SELECTORS, context);
  }, 1000);
}

window.Drupal.behaviors.ProductIntrofeature = {
  attach: (context) => {
    let blockCustom = context.querySelector(".product-intro");
    if (blockCustom && window.screen.width <= 1024) {
      let productOne = context.querySelectorAll(".product-intro__item:nth-child(1) .product-intro__content .product-intro__feature");
      let parentModal = context.querySelector(".product-intro__item:nth-child(1) .product-intro__content");
      CreaterModal(productOne, parentModal, context);

      let productOne2 = context.querySelectorAll(".product-intro__item:nth-child(2) .product-intro__content .product-intro__feature");
      let parentModal2 = context.querySelector(".product-intro__item:nth-child(2) .product-intro__content");
      CreaterModal(productOne2, parentModal2, context);
    }
  }
}